import { useCallback } from 'react';
import { surveyEventBus } from './surveyEventBus';
import type { SurveyTriggerKey, SurveyTriggerOptions } from './types';

export interface UseSurveyTriggerReturn {
  /**
   * Imperatively request a post-journey survey by key. Resolves to true if a
   * survey was shown, false if no active match exists or the user already
   * answered/dismissed it.
   *
   * The key is matched against PostHog `survey.name` or `survey.linked_flag_key`.
   *
   * Pass `{ persistDismissal: false }` to allow re-prompting after dismissal.
   */
  triggerSurvey: (key: SurveyTriggerKey, options?: SurveyTriggerOptions) => Promise<boolean>;
}

export function useSurveyTrigger(): UseSurveyTriggerReturn {
  const triggerSurvey = useCallback((key: SurveyTriggerKey, options?: SurveyTriggerOptions) => {
    return new Promise<boolean>((resolve) => {
      surveyEventBus.dispatch({
        key,
        context: options?.context,
        persistDismissal: options?.persistDismissal ?? true,
        resolve,
      });
    });
  }, []);

  return { triggerSurvey };
}
